module.exports = __webpack_public_path__ + "assets/img/f4b54972778a44e1e7c88aa466b646fc.png";